<template>
    <div>
        <div class="bm-overlay" v-if="isSideBarOpen && !noOverlay" />
        <div ref="sideNav" class="bm-menu">
            <nav class="bm-item-list">
                <slot></slot>
            </nav>
            <span class="bm-cross-button cross-style" @click="closeMenu" :class="{ hidden: !crossIcon }">
                <span v-for="(x, index) in 2" :key="x" class="bm-cross" :style="{ position: 'absolute', width: '3px', height: '14px',transform: index === 1 ? 'rotate(45deg)' : 'rotate(-45deg)'}">
                </span>
            </span>
        </div>

        <div ref="bmBurgerButton" class="bm-burger-button" @click="openMenu" :class="{ hidden: !burgerIcon }">
            <span class="bm-burger-bars line-style" :style="{top:20 * (index * 2) + '%'}" v-for="(x, index) in 3" :key="index"></span>
        </div>

    </div>
</template>

<script>
export default {
  name: 'menubar',
  data() {
    return {
      isSideBarOpen: false
    };
  },
  props: {
    isOpen: {
      type: Boolean,
      required: false
    },
    right: {
      type: Boolean,
      required: false
    },
    width: {
      type: [String],
      required: false,
      default: '300'
    },
    disableEsc: {
      type: Boolean,
      required: false
    },
    noOverlay: {
      type: Boolean,
      required: false,
      default: false,
    },
    onStateChange: {
      type: Function,
      required: false
    },
    burgerIcon: {
      type: Boolean,
      required: false,
      default: true
    },
    crossIcon: {
      type: Boolean,
      required: false,
      default: true
    },
    disableOutsideClick: {
      type: Boolean,
      required: false,
      default: false
    },
    closeOnNavigation: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    openMenu() {
      this.$emit('openMenu');
      this.isSideBarOpen = true;

      if (this.right) {
        this.$refs.sideNav.style.left = 'auto';
        this.$refs.sideNav.style.right = '0px';
      }
      // eslint-disable-next-line func-names
      this.$nextTick(function () {
        this.$refs.sideNav.style.width = this.width
          ? `${this.width}px`
          : '300px';
      });
    },

    closeMenu() {
      this.$emit('closeMenu');
      this.isSideBarOpen = false;
      this.$refs.sideNav.style.width = '0px';
    },

    closeMenuOnEsc(e) {
      // eslint-disable-next-line no-param-reassign
      e = e || window.event;
      if (e.key === 'Escape' || e.keyCode === 27) {
        this.closeMenu();
      }
    },
    documentClick(e) {
      const element = this.$refs.bmBurgerButton;
      let target = null;
      if (e && e.target) {
        target = e.target;
      }

      if (
        element
            && element !== target
            && !element.contains(target)
            && !this.hasClass(target, 'bm-menu')
            && this.isSideBarOpen
            && !this.disableOutsideClick
      ) {
        this.closeMenu();
      } else if (
        element
            && this.hasClass(target, 'bm-menu')
            && this.isSideBarOpen
            && this.closeOnNavigation
      ) {
        this.closeMenu();
      }
    },
    hasClass(element, className) {
      do {
        if (element.classList && element.classList.contains(className)) {
          return true;
        }
        // eslint-disable-next-line no-param-reassign
        element = element.parentNode;
      } while (element);
      return false;
    },
  },

  mounted() {
    if (!this.disableEsc) {
      document.addEventListener('keyup', this.closeMenuOnEsc);
    }
  },
  created() {
    document.addEventListener('click', this.documentClick);
  },
  destroyed() {
    document.removeEventListener('keyup', this.closeMenuOnEsc);
    document.removeEventListener('click', this.documentClick);
  },
  watch: {
    isOpen: {
      deep: true,
      immediate: true,
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          if (!oldValue && newValue) {
            this.openMenu();
          }
          if (oldValue && !newValue) {
            this.closeMenu();
          }
        });
      }
    },
    right: {
      deep: true,
      immediate: true,
      handler(oldValue, newValue) {
        if (oldValue) {
          this.$nextTick(() => {
            this.$refs.bmBurgerButton.style.left = 'auto';
            this.$refs.bmBurgerButton.style.right = '36px';
            this.$refs.sideNav.style.left = 'auto';
            this.$refs.sideNav.style.right = '0px';
            document.querySelector('.bm-burger-button').style.left = 'auto';
            document.querySelector('.bm-burger-button').style.right = '36px';
            document.querySelector('.bm-menu').style.left = 'auto';
            document.querySelector('.bm-menu').style.right = '0px';
            document.querySelector('.cross-style').style.right = '250px';
          });
        }
        if (newValue) {
          if (
            this.$refs.bmBurgerButton.hasAttribute('style')
          ) {
            this.$refs.bmBurgerButton.removeAttribute('style');
            this.$refs.sideNav.style.right = 'auto';
            document
              .querySelector('.bm-burger-button')
              .removeAttribute('style');
            document.getElementById('sideNav').style.right = 'auto';
            document.querySelector('.cross-style').style.right = '0px';
          }
        }
      }
    }
  }
};
</script>

<style>
    html {
      height: 100%;
    }
    .bm-burger-button {
      position: absolute;
      width: 36px;
      height: 30px;
      left: 36px;
      top: 36px;
      cursor: pointer;
      z-index: 9998;
    }
    .bm-burger-button.hidden {
      display: none;
    }
    .bm-burger-bars {
      background-color: #373a47;
    }
    .line-style {
      position: absolute;
      height: 20%;
      left: 0;
      right: 0;
    }
    .cross-style {
      position: absolute;
      top: 20px;
      right: 20px;
      cursor: pointer;
      padding: 8px;
      border-radius: 8px;
      transition: all 0.2s ease;
    }
    .cross-style:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }
    .bm-cross {
      background: var(--text-color-primary, #ffffff);
      transition: all 0.2s ease;
    }
    .cross-style:hover .bm-cross {
      background: var(--text-color-primary, #ffffff);
    }
    .bm-cross-button {
      height: 24px;
      width: 24px;
    }
    .bm-cross-button.hidden {
      display: none;
    }
    .bm-menu {
      height: 100%; /* 100% Full-height */
      width: 0; /* 0 width - change this with JavaScript */
      position: fixed; /* Stay in place */
      z-index: 1000; /* Stay on top */
      top: 0;
      left: 0;
      background-color: var(--highlight-color, #5b7b97); /* Use dynamic color */
      overflow-x: hidden; /* Disable horizontal scroll */
      padding-top: 80px; /* Place content from the top */
      transition: 0.3s; /* Smooth transition effect */
      z-index: 9998;
      box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
    }

    .bm-overlay {
      background: rgba(0, 0, 0, 0.3);
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.3);
      z-index: 9997;
    }
    .bm-item-list {
      color: var(--text-color-primary, #ffffff);
      margin: 0;
      padding: 0 20px;
      font-size: 16px;
    }
    .bm-item-list > * {
      display: flex;
      text-decoration: none;
      padding: 16px 20px;
      margin: 4px 0;
      border-radius: 8px;
      transition: all 0.2s ease;
      align-items: center;
      gap: 12px;
    }
    .bm-item-list > * > i {
      font-size: 18px;
      color: var(--text-color-primary, #ffffff);
      width: 20px;
      text-align: center;
    }
    .bm-item-list > *:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }
    .bm-item-list > * > span {
      font-weight: 500;
      color: var(--text-color-primary, #ffffff);
    }
    .bm-item-list > *:hover > span {
      color: var(--text-color-primary, #ffffff);
    }
</style>
